export default __webpack_public_path__ + "static/media/snareimmunity.e758caca.png";